export const EXSBITEMBRAND_CREATE_RESET = 'EXSBITEMBRAND_CREATE_RESET'
export const EXSBITEMBRAND_CREATE_SET_CREATED = 'EXSBITEMBRAND_CREATE_SET_CREATED'
export const EXSBITEMBRAND_CREATE_SET_ERROR = 'EXSBITEMBRAND_CREATE_SET_ERROR'
export const EXSBITEMBRAND_CREATE_SET_VIOLATIONS = 'EXSBITEMBRAND_CREATE_SET_VIOLATIONS'
export const EXSBITEMBRAND_CREATE_TOGGLE_LOADING = 'EXSBITEMBRAND_CREATE_TOGGLE_LOADING'
